<mat-accordion multi class="manage-container">

  <!-- Touchpoints Section -->
  <mat-expansion-panel expanded>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <typography variant="mat-subtitle-1" weight="bold">{{ appStrings.label_touchpoints }}</typography>
      </mat-panel-title>
    </mat-expansion-panel-header>

    @if (touchpoints.loading) {
      <div class="loading-container">
        <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
      </div>
    }

    @if (!touchpoints.loading && !touchpointsList.length) {
      <div class="no-results">{{ appStrings.noResults }}</div>
    }

    <div *appIsDesktop [hidden]="touchpoints.loading || !touchpointsList.length">
      <ds-table mat-table matSort [dataSource]="paginatedTouchpoints" [displayedColumns]="touchpointColumns" (matSortChange)="onTouchpointsSortChange($event)">

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>{{ appStrings.label_type }}</th>
          <td mat-cell *matCellDef="let element; let i = index">
            <ds-chip [class]="getTouchpointColor(element.touchpointType)" variant="filled" size="small">{{ templateValues?.TouchpointType[element.touchpointType] }}</ds-chip>
          </td>
        </ng-container>

        <ng-container matColumnDef="subject">
          <th mat-header-cell *matHeaderCellDef>{{ appStrings.label_subject }}</th>
          <td mat-cell *matCellDef="let element">{{ element.subject }}</td>
        </ng-container>

        <ng-container matColumnDef="company">
          <th mat-header-cell *matHeaderCellDef mat-sort-header id="touchpoint_company_header">{{ appStrings.accounts_company }}</th>
          <td mat-cell *matCellDef="let element" class="company-column">{{ element.company }}</td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>{{ appStrings.label_date }}</th>
          <td mat-cell *matCellDef="let element">{{ element.date | date:dateTimeFormat }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element; let i = index" (click)="$event.stopPropagation()">
            <div class="actions-row">
              <ds-button type="tertiary" size="medium" variant="label-only"
                [id]="'deleteTouchpoint_' + i"
                [label]="appStrings.button_delete"
                (onClick)="deleteTouchpoint(element)">
              </ds-button>
              <ds-button type="secondary" size="medium" variant="label-only"
                [id]="'mergeTouchpoint_' + i"
                [label]="appStrings.button_merge"
                (onClick)="openMergeTouchpointModal(element, $event)">
              </ds-button>
            </div>
          </td>
        </ng-container>

      </ds-table>

      <div class="pagination-container-desktop">
        <div class="page-count">
          <b>{{ (touchpointsPage - 1) * pageSize + 1 }} - {{ touchpointsPageEnd }}</b>
          {{ appStrings.pagination_of }}
          <b>{{ touchpointsList.length }}</b>
        </div>
        <div class="pagination-center">
          @if (touchpointsTotalPages > 1) {
            <ds-pagination
              [totalPages]="touchpointsTotalPages"
              paginationDisplay="large"
              buttonTypes="nextPrevFirstLast"
              [buttonsBefore]="3"
              (pageChanged)="onTouchpointsPageChange($event)">
            </ds-pagination>
          }
        </div>
      </div>
    </div>

    @if (!touchpoints.loading && touchpointsList.length) {
      <div *appIsMobile class="mobile">
        @for (element of paginatedTouchpoints; track element; let i = $index) {
          <mat-expansion-panel class="mobile-card header-columns tall blue-border" [expanded]="false">
            <mat-expansion-panel-header class="content-header">
              <mat-panel-title id="touchpoint-card-header-container-{{i}}" class="card-header-container">
                <span class="icon-start">
                  <span class="card-header-icon">
                    <ds-icon
                      class="round-icon"
                      [class]="getTouchpointColor(element.touchpointType)"
                      [icon]="getTouchpointIcon(element.touchpointType)"
                      iconStyle="material-icons-outlined"
                      [id]="'touchpointTypeIcon_mobile_' + i">
                    </ds-icon>
                  </span>
                  <span class="card-header">
                    <span id="touchpoint-card-title_{{i}}" class="title">{{ element.subject }}</span>
                    <span id="touchpoint-card-subtitle_{{i}}" class="subtitle">{{ element.date | date:dateTimeFormat }}</span>
                  </span>
                </span>
                <div class="mobile-card-actions" (click)="$event.stopPropagation()">
                  <ds-button type="secondary" size="medium" variant="label-only"
                    [id]="'deleteTouchpoint_mobile_' + i"
                    [label]="appStrings.button_delete"
                    (onClick)="deleteTouchpoint(element)">
                  </ds-button>
                  <ds-button type="primary" size="medium" variant="label-only"
                    [id]="'mergeTouchpoint_mobile_' + i"
                    [label]="appStrings.button_merge"
                    (onClick)="openMergeTouchpointModal(element, $event)">
                  </ds-button>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ds-divider></ds-divider>
            <div class="content">
              <div class="row">
                <div class="column">
                  <typography [id]="'touchpointType_label_' + i" class="label" variant="caption-2" weight="regular">
                    {{ appStrings.label_type }}
                  </typography>
                  <typography [id]="'touchpointType_' + i" variant="body-2" weight="medium">
                    {{ templateValues?.TouchpointType[element.touchpointType] ?? '-' }}
                  </typography>
                </div>
              </div>
              <div class="row">
                <div class="column">
                  <typography [id]="'touchpointCompany_label_' + i" class="label" variant="caption-2" weight="regular">
                    {{ appStrings.accounts_company }}
                  </typography>
                  <typography [id]="'touchpointCompany_' + i" variant="body-2" weight="medium">
                    {{ element.company || '-' }}
                  </typography>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        }

        @if (touchpointsTotalPages > 1) {
          <div class="pagination-container">
            <ds-paper elevation="elevation_none" borderRadius="radius_XS" outline="outlined"
              insidePaddingTop="top-spacing_S" insidePaddingBottom="bottom-spacing_S">
              <div class="pagination">
                <ds-pagination
                  id="touchpoints-mobile-pagination"
                  [totalPages]="touchpointsTotalPages"
                  paginationDisplay="small"
                  buttonTypes="nextPrevFirstLast"
                  (pageChanged)="onTouchpointsPageChange($event)">
                </ds-pagination>
              </div>
            </ds-paper>
          </div>
        }
      </div>
    }

  </mat-expansion-panel>

  <!-- Contacts Section -->
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <typography variant="mat-subtitle-1" weight="bold">{{ appStrings.label_contacts }}</typography>
      </mat-panel-title>
    </mat-expansion-panel-header>

    @if (contacts.loading) {
      <div class="loading-container">
        <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
      </div>
    }

    @if (!contacts.loading && !contactsList.length) {
      <div class="no-results">{{ appStrings.noResults }}</div>
    }

    <div *appIsDesktop [hidden]="contacts.loading || !contactsList.length">
      <ds-table mat-table matSort [dataSource]="paginatedContacts" [displayedColumns]="contactColumns" (matSortChange)="getContactsList($event)">

        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef>{{ appStrings.contacts_firstName }}</th>
          <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
        </ng-container>

        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header id="lastName_header">{{ appStrings.contacts_lastName }}</th>
          <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
        </ng-container>

        <ng-container matColumnDef="company">
          <th mat-header-cell *matHeaderCellDef mat-sort-header id="company_header">{{ appStrings.accounts_company }}</th>
          <td mat-cell *matCellDef="let element">{{ element.company }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element; let i = index" (click)="$event.stopPropagation()">
            <div class="actions-row">
              <ds-button type="tertiary" size="medium" variant="label-only"
                [id]="'deleteContact_' + i"
                [label]="appStrings.button_delete"
                (onClick)="deleteContact(element)">
              </ds-button>
              <ds-button type="secondary" size="medium" variant="label-only"
                [id]="'mergeContact_' + i"
                [label]="appStrings.button_merge"
                (onClick)="openMergeContactModal(element, $event)">
              </ds-button>
            </div>
          </td>
        </ng-container>

      </ds-table>

      <div class="pagination-container-desktop">
        <div class="page-count">
          <b>{{ (contactsPage - 1) * pageSize + 1 }} - {{ contactsPageEnd }}</b>
          {{ appStrings.pagination_of }}
          <b>{{ contactsList.length }}</b>
        </div>
        <div class="pagination-center">
          @if (contactsTotalPages > 1) {
            <ds-pagination
              [totalPages]="contactsTotalPages"
              paginationDisplay="large"
              buttonTypes="nextPrevFirstLast"
              [buttonsBefore]="3"
              (pageChanged)="onContactsPageChange($event)">
            </ds-pagination>
          }
        </div>
      </div>
    </div>

    @if (!contacts.loading && contactsList.length) {
      <div *appIsMobile class="mobile">
        @for (element of paginatedContacts; track element; let i = $index) {
          <mat-expansion-panel hideToggle class="mobile-card header-columns blue-border" [id]="'contact-card-' + i">
            <mat-expansion-panel-header class="content-header">
              <mat-panel-title class="card-header-container">
                <span class="card-header">
                  <span id="contact-card-title_{{i}}" class="title">{{ getFullContactName(element) }}</span>
                  <span id="contact-card-subtitle_{{i}}" class="subtitle">{{ element.company || '-' }}</span>
                </span>
                <div class="mobile-card-actions" (click)="$event.stopPropagation()">
                  <ds-button type="secondary" size="medium" variant="label-only"
                    [id]="'deleteContact_mobile_' + i"
                    [label]="appStrings.button_delete"
                    (onClick)="deleteContact(element)">
                  </ds-button>
                  <ds-button type="primary" size="medium" variant="label-only"
                    [id]="'mergeContact_mobile_' + i"
                    [label]="appStrings.button_merge"
                    (onClick)="openMergeContactModal(element, $event)">
                  </ds-button>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
        }

        @if (contactsTotalPages > 1) {
          <div class="pagination-container">
            <ds-paper elevation="elevation_none" borderRadius="radius_XS" outline="outlined"
              insidePaddingTop="top-spacing_S" insidePaddingBottom="bottom-spacing_S">
              <div class="pagination">
                <ds-pagination
                  id="contacts-mobile-pagination"
                  [totalPages]="contactsTotalPages"
                  paginationDisplay="small"
                  buttonTypes="nextPrevFirstLast"
                  (pageChanged)="onContactsPageChange($event)">
                </ds-pagination>
              </div>
            </ds-paper>
          </div>
        }
      </div>
    }

  </mat-expansion-panel>

</mat-accordion>

<ds-dialog
  [title]="deleteDialogTitle"
  [description]="deleteDialogDescription"
  [actionButtons]="deleteDialogButtons"
  [hasOverlay]="true"
  [disableClose]="false"
  [open]="deleteOpen$">
</ds-dialog>
